import { baseQuery } from '../baseQuery';

export const postVoipLogout = async () => {
  const { data } = await baseQuery('voip-logout', {
    type: 'POST',
  });

  return data;
};
